  query getReferringSites(
    $clientId: ID
    $projectId: ID
    $productIds: [ID]
    $startDate: AWSDateTime
    $endDate: AWSDateTime
  ) {
      referringSites: SalesAnalyticsGetReferringSites(
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      projectId: $projectId
      productIds: $productIds
      productView: BUNDLE
    ) {
      referringSite
      sales
      quantity
    }
  }